import React from 'react';
import { AppIconListItem } from '../../../_lib/components/AppIconList';
import {
  ContainerWithCommonContextMenu,
} from '../../../_lib/components/ContextMenu';
import { AppLibraryEditableElement } from '../AppLibraryTypes';
import { asDraggableContentListItem, useSortableListItem } from '../../../_lib/components/SortableContentList';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { StatusInfoError } from '../../../_lib/components/StatusInfo';
import { ContextMenuButtonProps } from '../../../_lib/components/ContextMenu/partials/ContextMenuButton';
import { SonForm } from '../../../_lib/Form2';
import { AppLibraryUpdateFormTypes } from './AppLibraryAddOrUpdateForm';

type AppLibraryListItemProps = AppLibraryEditableElement & {
  openEditForm?: (form: SonForm<AppLibraryUpdateFormTypes>) => void;
  openDeleteForm?: (form: SonForm<AppLibraryUpdateFormTypes>) => void;
};

function AppLibraryListItem({
  delete: deleteForm,
  edit,
  id,
  image,
  link,
  optional,
  openDeleteForm,
  openEditForm,
}: AppLibraryListItemProps) {
  const { t } = useSonTranslation('AppLibrary');
  const { move, nextItemId, prevItemId, error } = useSortableListItem(id);

  const contextMenuActions: ContextMenuButtonProps[] = [
    ...openEditForm
      ? [{
          children: t('editLink'),
          key: 'edit',
          onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();

            openEditForm(edit);
          },
        }] as ContextMenuButtonProps[]
      : [],
    ...openDeleteForm
      ? [{
          children: t('removeLink'),
          key: 'remove',
          onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();

            openDeleteForm(deleteForm);
          },
        }] as ContextMenuButtonProps[]
      : [],
    {
      children: t('moveUp'),
      key: 'moveElementUp',
      disabled: !prevItemId,
      onClick: (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (prevItemId) {
          move(prevItemId);
        }
      },
    },
    {
      children: t('moveDown'),
      key: 'moveElementDown',
      disabled: !nextItemId,
      onClick: (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (nextItemId) {
          move(nextItemId);
        }
      },
    },
  ];

  return (
    <div className="app-library__container">
      <ContainerWithCommonContextMenu
        toolTip={t('manageLink', { name: link.name })}
        actions={contextMenuActions}
      >
        <div className="app-library__element">
          {image?.src && (
            <div className="app-library__icon">
              <AppIconListItem modifier="small" src={image.src} />
            </div>
          )}
          <div className="app-library__content font-regular-15-21">
            {link.name + (optional ? ` (${t('optional')})` : '')}
          </div>
        </div>
      </ContainerWithCommonContextMenu>
      {error && <StatusInfoError message={t('errorResponse')} modifier="padding-top" />}
    </div>
  );
}
export const DraggableAppLibraryListItem = asDraggableContentListItem(AppLibraryListItem);
